import { IDataType } from "../../../shared/definitions/datatypes";
import { createUUID, IObject } from "../../../shared/utils/utils";

export interface IColumn {
  key: string;
  displayName: string;
  dataType: IDataType;
  sortable?: boolean;
}

export function transformToBackendDatamodelReportFiltering(data: any) { // eslint-disable-line
  return {
    report_id: data.report_id,
    query_filters: data.query_filters.map((filter: IObject) => ({
      field: filter.field,
      field_type: filter.field_type,
      op: filter.op,
      value: filter.value,
    }))
  };
}

export function transformFromBackendDatamodelReportFiltering(backendType: any) { // eslint-disable-line
  let columns: IColumn[] = [];
  if (backendType.columns) {
    columns = (backendType.columns ?? []).map((col: IObject) => ({
      key: col.key,
      displayName: col.title,
      dataType: col.datatype || { type: "text" },
      sortable: true
    }));
  }
  const result =  {
    columns,
    rowData: backendType.rows?.map((row: IObject) => ({
      id: createUUID(),
      ...row
    })) || [],
    name: backendType.name,
    datamodel_type: backendType.datamodel_type,
    datamodel_id: backendType.datamodel_id,
    created_at: backendType.created_at,
    report_id: backendType.report_id,
    query_filters: backendType.query_filters,
  };
  return result;
}
